<div class="my-5">
  <!-- <h4 class="large-h mb-0">{{title | translator}}</h4> -->
  <div *ngIf="projects.length <= 0" class="mt-2">
    <app-no-data></app-no-data>
  </div>
  <ng-container *ngIf="projects.length > 0">
    <div
      class="row flex-white-box-row-mob white-box-row 2222"
      *ngFor="let project of projects; let i = index"
    >
      <div class="col-md-3 col-12 p-0">
        <div class="d-flex align-items-center mob-w-100">
          <div>
            <div class="number-box">{{ i + 1 }}</div>
          </div>
          <h5 class="medium-h-row">{{ project.name }}</h5>
        </div>
      </div>
      <div class="col-md-6 col-12 mob-p-0">
        <div class="d-flex flex-wrap mob-m-t-b-1rem">
          <div class="detail-box"
          [pTooltip]="'External PM' | translator"
          >
            <i class="pi pi-user icon-ml"></i
            >{{ extractUsername(project?.vendor[0]?.name) }}
          </div>
          <div
          [pTooltip]="'Internal PM' | translator"
            tooltipPosition="top"
            class="detail-box"
          >
            <i class="pi pi-user icon-ml"></i
            >{{
              extractUsername(project?.internalPm[0]?.name).substring(0, 20)
            }}
            {{
              extractUsername(project?.internalPm?.name).length > 10
                ? "..."
                : null
            }}
          </div>
          <div
            [pTooltip]="'MS Description' | translator"
            tooltipPosition="top"
            class="detail-box"
          >
            <i class="fa fa-circle-info icon-ml"></i
            >{{ project.description?.substring(0, 20) }}
            {{ project.description.length > 10 ? "..." : null }}
          </div>
          <div
            [pTooltip]="'Start Date' | translator"
            tooltipPosition="top"
            class="detail-box"
          >
            <i class="pi pi-clock icon-ml"></i>
            {{ formatDate(project.startDate) }}
          </div>
          <div
            [pTooltip]="'End Date' | translator"
            tooltipPosition="top"
            class="detail-box"
          >
            <i class="pi pi-clock icon-ml"></i>
            {{ formatDate(project.endDate) }}
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12 p-0">
        <div class="responsive-flex">
          <div
            [pTooltip]="'Delete' | translator"
            *ngIf="!isVendor(project)"
            class="circle-btn"
            (click)="confirmDelete(project._id)"
          >
            <i class="fa fa-trash"></i>
          </div>
          <div
            [pTooltip]="'Edit' | translator"
            *ngIf="!isVendor(project)"
            class="circle-btn"
            [routerLink]="'/ms/project/update/' + project._id"
          >
            <i class="fa fa-pencil"></i>
          </div>
          <div
            [pTooltip]="'Dashboard' | translator"
            *ngIf="!isVendor(project)"
            class="circle-btn"
            [routerLink]="'/ms/dashboard/' + project._id"
          >
            <i class="pi pi-chart-line"></i>
          </div>
          <div
            [pTooltip]="'Assign Weights' | translator"
            *ngIf="
              isVendor(project) ||
              MsPermissionService.isInternalUserPM(project != undefined ? project.internalPm : null)
            "
            class="circle-btn"
            [routerLink]="'/ms/assign-weights/' + project._id"
          >
            <i class="pi pi-plus-circle"></i>
          </div>
          <div
            [pTooltip]="'Add Sessions' | translator"
            *ngIf="!isVendor(project)"
            class="circle-btn"
            [routerLink]="'/ms/session/' + project._id"
          >
            <i class="pi pi-calendar"></i>
          </div>
          <div
            [pTooltip]="'Evaluation' | translator"
            *ngIf="
              (isVendor(project) ||
                MsPermissionService.isInternalUserPM(
                  project != undefined ? project.internalPm : null
                )) &&
              canShowEvaluation(project.steps)
            "
            class="circle-btn"
            [routerLink]="'/ms/evaluation/' + project._id"
          >
            <i class="pi pi-pencil"></i>
          </div>
          <div
            [pTooltip]="'Factor Dashboard' | translator"
            *ngIf="canShowDashboard(project.responsibles)"
            class="circle-btn"
            [routerLink]="'/ms/factor-dashboard/' + project._id"
          >
            <i class="pi pi-chart-line"></i>
          </div>
          <div
            [pTooltip]="'Factor Status Update' | translator"
            *ngIf="canShowFactorStatus(project.responsibles)"
            class="circle-btn"
            [routerLink]="'/ms/factor-update-status/' + project._id"
          >
            <i class="pi pi pi-refresh"></i>
          </div>
          <div
            [pTooltip]="'Factor Status Approve' | translator"
            *ngIf="
              isPm(project) ||
              MsPermissionService.isInternalUserPM(project != undefined ? project.internalPm : null)
            "
            class="circle-btn"
            [routerLink]="'/ms/factor-status-approve/' + project._id"
          >
            <i class="pi pi pi-check"></i>
          </div>
          <div
            [pTooltip]="'Factors History - Reports' | translator"
            *ngIf="
              !isVendor(project) ||
              isPm(project) ||
              MsPermissionService.isInternalUserPM(project != undefined ? project.internalPm : null)
            "
            class="circle-btn"
            [routerLink]="'/ms/factor-reports'"
          >
            <i class="pi pi-list"></i>
          </div>
          <div
            [pTooltip]="'This Project have Approvals' | translator"
            *ngIf="
              project.statusCounts &&
              project.statusCounts.Approved &&
              !(
                isPm(project) ||
                MsPermissionService.isInternalUserPM(
                  project != undefined ? project.internalPm : null
                )
              )
            "
            class="circle-btn circle-btn-success"
            [routerLink]="'/ms/assign-weights/' + project._id"
          >
            {{ project.statusCounts.Approved }}
          </div>
          <div
            [pTooltip]="'This Project have Redos' | translator"
            *ngIf="
              project.statusCounts &&
              project.statusCounts.Redo &&
              !(
                isPm(project) ||
                MsPermissionService.isInternalUserPM(
                  project != undefined ? project.internalPm : null
                )
              )
            "
            class="circle-btn circle-btn-danger"
            [routerLink]="'/ms/assign-weights/' + project._id"
          >
            {{ project.statusCounts.Redo }}
          </div>
          <div
            [pTooltip]="'This Project have Pending Approvals' | translator"
            *ngIf="
              project.statusCounts &&
              project.statusCounts.Pending &&
              (isPm(project) ||
                MsPermissionService.isInternalUserPM(
                  project != undefined ? project.internalPm : null
                ))
            "
            class="circle-btn circle-btn-warning"
            [routerLink]="'/ms/assign-weights/' + project._id"
          >
            {{ project.statusCounts.Pending }}
          </div>
          <div
            [pTooltip]="'This Project have Pending Changes' | translator"
            *ngIf="
              project.statusCounts &&
              project.statusCounts.Change &&
              !(
                isPm(project) ||
                MsPermissionService.isInternalUserPM(
                  project != undefined ? project.internalPm : null
                )
              )
            "
            class="circle-btn circle-btn-info"
            [routerLink]="'/ms/assign-weights/' + project._id"
          >
            {{ project.statusCounts.Change }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
